import React, { Component } from 'react';
import Exporter from './../../Core/Exporter';

class Stats extends Component {
  render() {
    // font-weight-normal
    return (
      <div className='col'>
        <div className='card m-3 p-3'>
          <div className='card-body'>
            <h4 className='card-title'>Statistiques</h4>
            <div className='row no-gutters'>
              <div className='col-12 col-md-3 my-1'>
                <div className='mr-md-2 px-2 border rounded'>
                  <h3 className='text-secondary'>{this.props.stats.clients}</h3>
                  <h5 className='text-secondary'>Clients</h5>
                </div>
              </div>
              <div className='col-12 col-md-3 my-1'>
                <div className='mx-md-2 px-2 border rounded'>
                  <h3 className='text-secondary'>{this.props.stats.emails}</h3>
                  <h5 className='text-secondary'>Emails</h5>
                </div>
              </div>
              <div className='col-12 col-md-3 my-1'>
                <div className='mx-md-2 px-2 border rounded'>
                  <h3 className='text-secondary'>{this.props.stats.phones}</h3>
                  <h5 className='text-secondary'>Téléphone</h5>
                </div>
              </div>
              <div className='col-12 col-md-3 my-1'>
                <div className='ml-md-2 px-2 border rounded'>
                  <h3 className='text-secondary'>{this.props.stats.phone_mobiles}</h3>
                  <h5 className='text-secondary'>Mobile</h5>
                </div>
              </div>
              <div className='col-12 col-md-3 my-1'>
                <div className='mr-md-2 px-2 border rounded'>
                  <h3 className='text-secondary'>{this.props.stats.leads}</h3>
                  <h5 className='text-secondary'>Leads</h5>
                </div>
              </div>
              <div className='col-12 col-md-3 my-1'>
                <div className='mx-md-2 px-2 border rounded'>
                  <h3 className='text-secondary'>{this.props.stats.apv}</h3>
                  <h5 className='text-secondary'>APV</h5>
                </div>
              </div>
              <div className='col-12 col-md-3 my-1'>
                <div className='mx-md-2 px-2 border rounded'>
                  <h3 className='text-secondary'>{this.props.stats.opinion}</h3>
                  <h5 className='text-secondary'>Avis client</h5>
                </div>
              </div>
              <div className='col-12 col-md-3'></div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default Stats;



// WEBPACK FOOTER //
// ./src/Components/Search/Stats.js